import _extends from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import querystring from 'query-string';
import LoginInterface from '../../api/LoginInterface';
import Utils from '../../utils';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Screens from '..';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
import { getText, TEXT_KEY } from '../../utils/localization';

var LinkLoyaltyCard = /*#__PURE__*/function (_Component) {
  _inherits(LinkLoyaltyCard, _Component);

  var _super = _createSuper(LinkLoyaltyCard);

  function LinkLoyaltyCard() {
    var _this;

    _classCallCheck(this, LinkLoyaltyCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      serverResponse: '',
      flowStep: LinkLoyaltyCard.FLOW_STEPS.LOADING,
      ssoInitLinkResponse: {},
      linkedSuccessfully: false,
      formSubmitted: false
    };
    _this.onSubmit = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var email, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              email = _this.props.formInfo.email.value;
              _context.prev = 1;

              if (_this.state.formSubmitted) {
                _context.next = 9;
                break;
              }

              _this.setState({
                formSubmitted: true,
                serverResponse: ''
              });

              _this.setState({
                title: getText(TEXT_KEY.PROCESSING)
              });

              _context.next = 7;
              return LoginInterface.ssoLinkLoyaltyCard(_objectSpread(_objectSpread({}, _this.state.ssoInitLinkResponse), {}, {
                email: email
              }));

            case 7:
              response = _context.sent;

              _this.onLinkSuccess(response);

            case 9:
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);

              _this.setState({
                serverResponse: _context.t0,
                formSubmitted: false,
                title: getText(TEXT_KEY.UNABLE_TO_LINK_CARD)
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11]]);
    }));

    _this.onDismiss = function () {
      var _this$props = _this.props,
          callbackIntent = _this$props.callbackIntent,
          clearCallbackIntent = _this$props.clearCallbackIntent,
          navigation = _this$props.navigation,
          addNotif = _this$props.addNotif,
          initiatePurchase = _this$props.initiatePurchase;

      if (_this.state.linkedSuccessfully) {
        if (callbackIntent.purchaseData) {
          var _queryParams;

          var _callbackIntent$purch = callbackIntent.purchaseData,
              purchaseType = _callbackIntent$purch.purchaseType,
              sku = _callbackIntent$purch.sku,
              name = _callbackIntent$purch.name;
          var queryParams = (_queryParams = {}, _defineProperty(_queryParams, RouteParamConstants.PARAM_PURCHASE_TYPE, purchaseType), _defineProperty(_queryParams, RouteParamConstants.PARAM_PURCHASE_SKU, sku), _defineProperty(_queryParams, RouteParamConstants.PARAM_PURCHASE_NAME, name), _queryParams);

          if (Utils.getPlatform() === 'web') {
            if (ENVIRONMENT_VARIABLES.APPLICATION_TARGET === 'star') {
              queryParams[RouteParamConstants.PARAM_MODAL] = Screens.CurrencySelector;
            } else {
              queryParams[RouteParamConstants.PARAM_MODAL] = Screens.PurchaseFlow;
            }
          } else {
            initiatePurchase();
          }

          QueryParamsProxy.setQueryParams(queryParams);
        }

        addNotif({
          title: getText(TEXT_KEY.YOUR_ACCOUNT_IS_NOW_LINKED),
          message: getText(TEXT_KEY.ACCOUNT_LINKED_MESSAGE)
        });
      }

      clearCallbackIntent();
      QueryParamsProxy.navigate(navigation, Screens.Lobby);
    };

    _this.onLinkSuccess = function (linkResponse) {
      var sessionId = linkResponse.sessionId,
          restartToken = linkResponse.restartToken,
          playerId = linkResponse.playerId;
      Logger.sendEvent(EVENT_TYPES.REGISTRATION_COMPLETE, {
        type: 'email'
      });

      if (playerId) {
        _this.props.setPlayerId(playerId);
      }

      if (sessionId && restartToken) {
        _this.props.setAuthorized(true);

        _this.props.setToken(sessionId);

        _this.props.setRestart(restartToken);

        _this.props.setLastInitApp(1); // force LobbyOverlay to call initApp again when the session is replaced

      }

      _this.setState({
        linkedSuccessfully: true
      }, _this.onDismiss);
    };

    return _this;
  }

  _createClass(LinkLoyaltyCard, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var code, parameters, response, _response, email, casinoId, ssoAccessToken, ssoRefreshToken, errorDetails;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (Utils.getPlatform() === 'web') {
                  parameters = querystring.parse(document.location.search.replace(/^.*\?/, ''));
                  code = parameters.code;
                } else {
                  code = this.props.navigation.getParam('code', null);
                }

                if (!code) {
                  _context2.next = 22;
                  break;
                }

                QueryParamsProxy.setQueryParams({
                  code: undefined
                });
                _context2.prev = 3;
                _context2.next = 6;
                return LoginInterface.ssoInitLinkLoyaltyCard(code);

              case 6:
                response = _context2.sent;

                if (!response.playerId) {
                  _context2.next = 10;
                  break;
                }

                this.onLinkSuccess(response);
                return _context2.abrupt("return");

              case 10:
                _response = response, email = _response.email, casinoId = _response.casinoId, ssoAccessToken = _response.ssoAccessToken, ssoRefreshToken = _response.ssoRefreshToken;
                this.setState({
                  flowStep: LinkLoyaltyCard.FLOW_STEPS.CONFIRM_EMAIL,
                  ssoInitLinkResponse: {
                    email: email,
                    casinoId: casinoId,
                    ssoAccessToken: ssoAccessToken,
                    ssoRefreshToken: ssoRefreshToken
                  }
                });
                this.props.prepopulateForm({
                  key: 'email',
                  value: email,
                  validated: true
                });
                _context2.next = 20;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](3);
                errorDetails = _context2.t0 ? {
                  serverResponse: _context2.t0,
                  title: getText(TEXT_KEY.UNABLE_TO_LINK_CARD)
                } : {
                  serverResponse: getText(TEXT_KEY.SESSION_EXPIRED),
                  title: getText(TEXT_KEY.TRY_LINKING_AGAIN)
                };
                this.setState(_objectSpread(_objectSpread({}, errorDetails), {}, {
                  flowStep: LinkLoyaltyCard.FLOW_STEPS.SHOW_MESSAGE
                }));
                this.props.clearCallbackIntent();

              case 20:
                _context2.next = 23;
                break;

              case 22:
                this.onDismiss();

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 15]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var additionalProps = _extends({}, this.props);

      return this.props.render(_objectSpread(_objectSpread(_objectSpread({}, this.state), additionalProps), {}, {
        submitHandler: this.onSubmit,
        onDismiss: this.onDismiss
      }));
    }
  }]);

  return LinkLoyaltyCard;
}(Component);

LinkLoyaltyCard.FLOW_STEPS = {
  LOADING: 'LOADING',
  CONFIRM_EMAIL: 'CONFIRM_EMAIL',
  SHOW_MESSAGE: 'SHOW_MESSAGE'
};
export { LinkLoyaltyCard as default };